import React from "react";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

import AboutUsSection from "./index-sections/AboutUs.js";
import ProductsSection from "./index-sections/Products.js";
import ServicesSection from "./index-sections/Services.js";
import ContactUsSection from "./index-sections/ContactUs.js";

function Index() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader />
        <div className="main">
          <AboutUsSection />
          <ServicesSection />
          <ProductsSection />
          <ContactUsSection />
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default Index;
